import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider.jsx";
import { evaluatePostValuePaywall } from "./api.js";

const SESSION_KEY_PREFIX = "axon.paywall.shadow.evaluated.v1";

export function PostValuePaywallShadow() {
  const auth = useAuth();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname !== "/" || auth.status !== "authenticated" || !auth.user?.uid) return;
    const sessionKey = `${SESSION_KEY_PREFIX}:${auth.user.uid}`;
    try {
      if (globalThis.sessionStorage?.getItem(sessionKey)) return;
      globalThis.sessionStorage?.setItem(sessionKey, "1");
    } catch {
      // Storage is only a duplicate-call guard; the server remains authoritative.
    }

    void Promise.resolve(auth.getIdToken())
      .then((token) => (token ? evaluatePostValuePaywall(token) : null))
      .catch(() => {
        // Shadow monetization telemetry must never block the working dialogue.
      });
  }, [auth, pathname]);

  return null;
}
